export enum ValidationMethod {
  Validated = 'validated',
  NeedValidation = 'need-validation',
  PoV = 'pov'
}

export enum ValidationSection {
  Qualification = 'Qualification',
  TestCases = 'Test Cases',
  Deployment = 'Deployment',
  Validation = 'Validation',
  PoV = 'PoV Details',
  Readout = 'Readout'
}